import React from 'react';
import T from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

const PublicApiTokenManagementIcon = ({ hasAccess, userId }) => {
  const { t } = useTranslation();
  const accessState = hasAccess ? 'enabled' : 'disabled';

  return (
    <Tooltip title={t('products.production_monitoring_public_api')} placement="top" arrow>
      <span
        data-testid={`public-api-token-management-${accessState}-${userId}`}
        style={{ display: 'inline-flex', lineHeight: 0 }}
      >
        <VpnKeyOutlinedIcon sx={{ color: hasAccess ? '#007167' : '#BCBDC1', fontSize: 16 }} />
      </span>
    </Tooltip>
  );
};

PublicApiTokenManagementIcon.propTypes = {
  hasAccess: T.bool.isRequired,
  userId: T.string.isRequired
};

export default PublicApiTokenManagementIcon;
